import React from 'react'
import { CardSectionReason } from './CardSectionReason'

export const VideoGameCourseReason = () => {
    return (
        <div className="flex flex-wrap px-8 md:px-16 pb-10">
            <div className='w-full flex flex-wrap  justify-center gap-x-8'>
                <CardSectionReason order='1' title='Besarnya Gaji' descriptionBold='Rp 6.000.000 s.d Rp8.400.000' />
                <CardSectionReason order="2" title="Besarnya Prospek Industri" descriptionNonBold='Industri yang terus diminati oleh seluruh kalangan masyarakat' />
                <CardSectionReason order='3' title='Luasnya Lowongan Pekerjaan' descriptionNonBold='Game designer, Game developer, Animator, Game Quality Assurance' />
            </div>
        </div>
    )
}